import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContatoService {
  private urlApi = environment.rootUrlApi + 'contato';

  constructor(private http: HttpClient) { }

  public contatoEscola(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/contatoEscola', dados);
  }

  public contatoUsuario(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/contatoUsuario', dados);
  }
  // public listaParcelas(id: number, guid: string): Observable<any> {
  //   return this.http.get<any>(this.urlApi + '/getParcelasEscola/' + id + '/' + guid);
  // }
}
